import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SHIPMENTMETHOD,
  DELETE_SHIPMENTMETHOD,
  UPDATE_SHIPMENTMETHOD,
  ADD_NEW_SHIPMENTMETHOD,
} from "./actionType";

import {
  getShipmentMethodSuccess,
  getShipmentMethodFail,
  deleteShipmentMethodSuccess,
  deleteShipmentMethodFail,
  updateShipmentMethodSuccess,
  updateShipmentMethodFail,
  addShipmentMethodSuccess,
  addShipmentMethodFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveShipmentMethodApi,
  getShipmentMethodApi,
  updateShipmentMethodApi,
  deleteShipmentMethodApi,
  addNewShipmentMethodApi
} from "../../helpers/backend_helper";

function* getShipmentMethod({ payload: shipmentMethod }) {
  try {
    const response = yield call(getShipmentMethodApi, shipmentMethod);
    yield put(getShipmentMethodSuccess(GET_SHIPMENTMETHOD, response.data));
  } catch (error) {
    yield put(getShipmentMethodFail(GET_SHIPMENTMETHOD, error));
  }
}

function* onUpdateShipmentMethod({ payload: shipmentMethod }) {
  try {
    if (shipmentMethod.setApprove) {
      const response = yield call(approveShipmentMethodApi, shipmentMethod);
      yield put(updateShipmentMethodSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateShipmentMethodApi, shipmentMethod);
      yield put(updateShipmentMethodSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateShipmentMethodFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteShipmentMethod({ payload: shipmentMethod }) {
  try {
    const response = yield call(deleteShipmentMethodApi, shipmentMethod);
    yield put(deleteShipmentMethodSuccess({ shipmentMethod, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteShipmentMethodFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewShipmentMethod({ payload: shipmentMethod }) {
  try {
    const response = yield call(addNewShipmentMethodApi, shipmentMethod);
    yield put(addShipmentMethodSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addShipmentMethodFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetShipmentMethod() {
  yield takeEvery(GET_SHIPMENTMETHOD, getShipmentMethod);
}

export function* watchUpdateShipmentMethod() {
  yield takeEvery(UPDATE_SHIPMENTMETHOD, onUpdateShipmentMethod);
}

export function* watchDeleteShipmentMethod() {
  yield takeEvery(DELETE_SHIPMENTMETHOD, onDeleteShipmentMethod);
}

export function* watchAddNewShipmentMethod() {
  yield takeEvery(ADD_NEW_SHIPMENTMETHOD, onAddNewShipmentMethod);
}

function* shipmentMethodSaga() {
  yield all([
    fork(watchGetShipmentMethod),
    fork(watchDeleteShipmentMethod),
    fork(watchUpdateShipmentMethod),
    fork(watchAddNewShipmentMethod)
  ]);
}

export default shipmentMethodSaga;
